import { useState, useMemo } from 'react';
import { AbyssIcon } from '@/assets/icons/AbyssIcon';
import { Button } from '@mui/material';
import { useGroupedPois } from './hooks/useGroupedPois';
import { ReportInternalType } from '@/__generated__/graphql';
import { AddToComponentReport } from '@/components/shared/ReportsRevamped/ComponentReports/AddToComponentReport';
import { useFilterCviAndGviPois } from './hooks/useFilterCviAndGviPois';
import { useAtomValue } from 'jotai';
import * as state from '@/components/Analysis/state';

export const GenerateReport = () => {
  const [createReportModalOpen, setCreateReportModalOpen] = useState(false);
  const handleOpen = () => setCreateReportModalOpen(true);
  const handleClose = () => setCreateReportModalOpen(false);

  const selectedAssemblyId = useAtomValue(state.selectedAssemblyId);
  const loadingPOIsForReviewReport = useAtomValue(state.loadingPOIsForReviewReport);

  const { loading } = useGroupedPois();

  const { cviPois, gviPois } = useFilterCviAndGviPois();

  const selectedPointOfInterestIds = useMemo(() => {
    const allPois = [...cviPois, ...gviPois];

    return allPois.map((poi) => poi.id);
  }, [cviPois, gviPois]);

  return (
    <>
      <Button
        variant="contained"
        size="small"
        startIcon={<AbyssIcon iconName="report" size="md" />}
        onClick={handleOpen}
        disabled={loading || !selectedAssemblyId || loadingPOIsForReviewReport}
      >
        Generate Report
      </Button>
      <AddToComponentReport
        title="Create Report"
        open={createReportModalOpen}
        selectedPointOfInterestIds={selectedPointOfInterestIds}
        handleClose={handleClose}
        componentIds={selectedAssemblyId ? [selectedAssemblyId] : []}
        internalType={ReportInternalType.Component}
      />
    </>
  );
};
